import React, { FC } from 'react';
import {
  Container,
  Grid,
  IconButton,
  makeStyles,
  Slide,
  Toolbar,
  Typography,
} from '@material-ui/core';
import { fade } from '@material-ui/core/styles';
import LaptopIcon from '@material-ui/icons/Laptop';
import CloseIcon from '@material-ui/icons/Close';
import { useTranslation } from 'react-i18next';

import { useUpdateUserProfileMutation } from 'api';
import { useCurrentUser } from 'hooks';
import storage from 'storage';

interface IProps {
  onDismissed: () => void;
  cookieValue: string;
}

const useStyles = makeStyles(theme => ({
  '@global #sticky-sidebar': {
    top: theme.custom.sidebarOffset + 48, // dense toolbar height
    height: `calc(100vh - ${theme.custom.sidebarOffset + 48}px)`,
  },
  background: {
    width: '100%',
    backgroundColor: fade(theme.palette.primary.main, 0.1),
    padding: theme.spacing(1, 0),
  },
  text: {
    cursor: 'pointer',
  },
  icon: {
    marginRight: theme.spacing(),
  },
  closeIcon: {
    position: 'absolute',
    right: 15,
  },
}));

const PushNotification: FC<IProps> = ({ cookieValue, onDismissed }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const currentUser = useCurrentUser();

  const { mutate } = useUpdateUserProfileMutation();

  function handleRequestPermission() {
    window.UA.then((sdk: any) => {
      sdk
        .register()
        .then(handleUpdateProfile)
        .catch(() => {
          if (Notification.permission === 'denied') {
            onDismissed();
          }
        });
    });
  }

  function handleCancel() {
    storage.pushNotification = cookieValue;
    onDismissed();
  }

  function handleUpdateProfile(channel: any) {
    const data = {
      id: currentUser.id,
      push_notification_configuration: [
        {
          device_platform: 'web',
          token: `AirshipPushToken[${channel.id}]`,
        },
      ],
    };

    channel.namedUser.set(currentUser.id);
    mutate({ data });
    onDismissed();
  }

  return (
    <Slide in mountOnEnter unmountOnExit>
      <Toolbar disableGutters variant="dense">
        <Grid className={classes.background}>
          <Container>
            <Grid container direction="row" alignItems="center" justify="center">
              <LaptopIcon color="primary" className={classes.icon} />

              <Typography
                onClick={handleRequestPermission}
                className={classes.text}
                variant="subtitle1"
                color="primary"
              >
                {t('components:pushNotification')}
              </Typography>

              <IconButton onClick={handleCancel} className={classes.closeIcon}>
                <CloseIcon color="primary" />
              </IconButton>
            </Grid>
          </Container>
        </Grid>
      </Toolbar>
    </Slide>
  );
};

export default PushNotification;
